import { Button, Dialog } from "@/components/Elements";
import { InputField } from "@/components/Form";
import { RootState } from "@/store/reducers";
import { PropsWithChildren, useMemo, useState } from "react";
import { useSelector } from "react-redux";

const TranslateText = ({
  text,
  onTranslated,
  handleClose,
}: PropsWithChildren<{
  text: string;
  onTranslated: (text: string) => void;
  handleClose: () => void;
}>) => {
  const { languageList } =
    useSelector((state: RootState) => state.appData.appData) ?? {};
  const [searchBy, setSearchBy] = useState("");

  const languages = useMemo(() => {
    if (searchBy) {
      return languageList.filter((c) =>
        c.text?.toLowerCase().includes(searchBy.toLowerCase())
      );
    }

    return languageList;
  }, [languageList, searchBy]);

  const handleTranslate = (toLanguage: string) => {
    const apiUrl = `https://api.mymemory.translated.net/get?q=
        ${text}&langpair=${`en-Gb`}|${toLanguage}`;

    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        onTranslated(data.responseData.translatedText);
        data.matches.forEach((data: any) => {
          if (data.id === 0) {
            onTranslated(data.translation);
          }
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="flex">
      <div>
        <InputField
          name="searchBy"
          placeholder="Search Languages"
          label="Search Languages"
          value={searchBy}
          onChange={(name, value) => setSearchBy(value)}
        />
        {languages?.map((item) => (
          <div
            key={item.value}
            className="border-b-2"
            onClick={() => handleTranslate(item.value)}
          >
            <div className="cursor-pointer px-4 py-2 ">{item.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranslateText;
